/**
 * @file paddle page
 * @author wanzhongyun
 */

import React from 'react';

import Header from '../../components/header/HeaderWithStore';
import Banner from './components/banner/Banner';
import Features from './components/features/Features';
import GetStart from './components/getStart/GetStart';
import Projects from './components/projects/Projects';
import Products from './components/products/Products';
import Support from './components/support/Support';
import Powered from './components/powered/Powered';
import Impact from './components/impact/Impact';
import LinkResource from './components/link-resource/LinkResource';

import useIndex from './IndexIndexHooks';
import Footer from '../../components/footer/Footer';


const IndexIndex: React.FC = () => {

    const { 
        interBanner,
        interFeatures,
        quickInstall,
        quickStartHooks,
        interOnlineExp,
        interMLProject,
        interProducts,
        interSupport,
        interPower,
        interImpact
    } = useIndex();

    return (
        <div>
            <Header />
            <Banner {...interBanner} />
            {
                interBanner.title && <div>
                    
                    <Features {...interFeatures} />
                    <GetStart quickStartHooks={quickStartHooks} quickInstall={quickInstall ?? {title: '', subtitle: ''}} interOnlineExp={interOnlineExp} />
                    <Projects  {...interMLProject} />
                    <Products {...interProducts} />
                    <Support {...interSupport} />
                    <Powered {...interPower} />
                    <Impact {...interImpact} />
                    <LinkResource />
                    <Footer />
                </div>
            }
        </div>
    );
};

export default IndexIndex;
